// const actions = {
//     FETCH_FINAL : 'FETCH_FINAL',
//
//     fetchFinalAction: (data) => {
//         return {
//             type: actions.FETCH_FINAL,
//             data: data
//         };
//     },
// }
//
// export default actions;


const actions = {
    FETCH_FINAL : 'FETCH_FINAL',
    UPDATE_SINGLE_STUDENT_FINAL: 'UPDATE_SINGLE_STUDENT_FINAL',

    fetchFinalAction: (data) => {
        return {
            type: actions.FETCH_FINAL,
            data: data
        };
    },

    updateSingleStudentFinalAction: (updatedRecord) => {
        return {
            type: actions.UPDATE_SINGLE_STUDENT_FINAL,
            data: updatedRecord
        };
    }
}

export default actions;
